import {defineStore} from "pinia";
import {ref, markRaw, Ref, UnwrapRef} from "vue";
import {ModalState} from "@/Types/index.d";

export const useModalStore = defineStore('modalStore', () => {
    const state: Ref<UnwrapRef<ModalState>> = ref<ModalState>({
        component: null,
        props: {},
        callbacks: [],
    })

    const open = (newState: ModalState): void => {
        state.value.component = markRaw(newState.component as object) // markRaw to avoid performance warning
        state.value.props = newState.props || {}
        state.value.callbacks = newState.callbacks || []
    }

    const close = (): void => {
        state.value.component = null
        state.value.props = {}
        state.value.callbacks = []
    }

    return {
        state,
        open,
        close
    }
})
